import React from 'react';
import {Link} from 'react-router';
import { EditableText} from '@blueprintjs/core';
import { PhoneNumber, CMNDNumber } from 'base/lib/validate';

export default class RowItemListGroupTypeReception extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      hoVaTen: this.props.item.hoVaTen,
      cmndHoChieu: this.props.item.cmndHoChieu,
      diaChi: this.props.item.diaChi,
      soDienThoai: this.props.item.soDienThoai,
      doanDiCungId: this.props.item.doanDiCungId
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      hoVaTen: nextProps.item.hoVaTen,
      cmndHoChieu: nextProps.item.cmndHoChieu,
      diaChi: nextProps.item.diaChi,
      soDienThoai: nextProps.item.soDienThoai,
      doanDiCungId: this.props.item.doanDiCungId
    });
  }

  onChange(name, type, e) {
    if(type == 'sdt') {
      e = PhoneNumber(e)
    }
    if (type == 'cmnd') {
      e = CMNDNumber(e);
    }
    this.state[name] = e;
    this.setState({...this.state});   
    this.props.parent.onChange(this.props.count-1, this.state);
  }

  render() {
    return (
      <tr>
        <td style={{width: 45, minWidth: 45, maxWidth: 45, textAlign: 'center'}}>{this.props.count}</td>
        <td style={{width: 185, minWidth: 185, maxWidth: 185}}>
          <EditableText
            placeholder="Họ và tên..." value={this.state.hoVaTen} maxLength={40}
            onConfirm={this.props.parent.addItem.bind(this.props.parent)}
            onChange={this.onChange.bind(this, 'hoVaTen', '')}
          />
        </td>
        <td style={{width: 145, minWidth: 145, maxWidth: 145}}>
          <EditableText
            placeholder="Số CMND/ Hộ chiếu..." value={this.state.cmndHoChieu} maxLength={10}
            onChange={this.onChange.bind(this, 'cmndHoChieu', 'cmnd')}
          />
        </td>
        <td style={{width: 340, minWidth: 340, maxWidth: 340}}>
          <EditableText
            placeholder="Địa chỉ..." maxLength={70} value={this.state.diaChi}
            onChange={this.onChange.bind(this, 'diaChi', '')}
          />
        </td>
        <td style={{width: 160, minWidth: 160, maxWidth: 160}}>
          <EditableText
            placeholder="Số điện thoại..." value={this.state.soDienThoai} maxLength={15}
            onChange={this.onChange.bind(this, 'soDienThoai', 'sdt')}
          />
        </td>
        <td style={{minWidth: 110}}>
          {
            this.state.hoVaTen ?
              <div className="todo-wrap two-item">
                <Link className="itt-delete" onClick={this.props.parent.handleRemove.bind(this.props.parent, (this.props.count - 1))}>
                  Xóa
                </Link>
              </div>
            : null
          }
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/add/RowItemListGroupTypeReception.jsx